import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';
import { dealTransformer } from '../transformer';

export default function useGetDealsBoard(params: { pipelineId?: string } = {}) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery({
    queryKey: [c.PIPELINES, params.pipelineId, c.DEALS, c.BOARD, params],
    queryFn: async () => {
      const api = new Api(args);

      const data: ReturnType<typeof dealTransformer.dealsBoard> = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/sales/deals',
            transformer: dealTransformer.dealsBoard,
            params: removeEmpty({ ...params, include: ['company', 'lead'] }),
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals`,
            transformer: dealTransformer.dealsBoard,
            params: removeEmpty({ ...params, include: ['company', 'lead'] }),
          },
        }),
      );

      return data.data;
    },
    enabled: !!params.pipelineId,
  });
}
